<template>
  <v-form>
    <v-container grid-list-xs>
      <v-layout column>
        <v-flex xs12 lg6>
          <v-card>
            <v-card-title>
              <div class="headline text-truncate">Summary</div>
            </v-card-title>
            <v-card-text>
              <v-flex>
                <v-select label="Gender"></v-select>
                <v-text-field label="Firstname"></v-text-field>
                <v-text-field label="Middlename"></v-text-field>
                <v-text-field label="Surname"></v-text-field>
              </v-flex>
              <v-btn  dark fab small color="pink darken-3"><v-icon>add</v-icon></v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 lg6>
          <v-card>
            <v-card-title>
              <div class="headline text-truncate">Identification</div>
            </v-card-title>
            <v-card-text>
              <v-flex>
                <v-layout row>
                  <v-text-field label="Date of birth" mask="date"></v-text-field>
                  <v-btn flat icon color="pink darken-3"><v-icon small>edit</v-icon></v-btn>
                  <v-btn flat icon color="pink darken-3"><v-icon small>delete</v-icon></v-btn>
                </v-layout>

                <v-layout row>
                  <v-text-field label="Middlename"></v-text-field>
                  <v-btn flat icon color="pink darken-3"><v-icon small>edit</v-icon></v-btn>
                  <v-btn flat icon color="pink darken-3"><v-icon small>delete</v-icon></v-btn>
                </v-layout>
                <v-text-field label="Surname"></v-text-field>
              </v-flex>
              <v-btn  dark fab small color="pink darken-3"><v-icon>add</v-icon></v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 lg6>
          <v-card>
            <v-card-title>
              <div class="headline text-truncate">Important Documents</div>
            </v-card-title>
            <v-card-text>
              <v-btn  dark fab small color="pink darken-3"><v-icon>add</v-icon></v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>

export default {
  name: "Schema",
  data: () => ({
  }),
  props: {
  },
  methods: {
  }
}
</script>
